<template>
  <el-row class="userheder">
    <el-col :span="20">
      <el-form
        :inline="true"
        :model="formSearch"
        ref="formSearch"
        class="demo-form-inline"
      >
        <el-col class="date">
          <el-form-item label="日期" class="date-wrap">
            <el-date-picker
              v-model="formSearch.formdate"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              style="width: 320px"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="维度">
            <el-select v-model="formSearch.dimension" placeholder="全部">
              <el-option label="全部" value="1"></el-option>
              <el-option label="国家和地区" value="2"></el-option>
            </el-select>
          </el-form-item>
          <!-- </el-col>
        <el-col> -->
          <el-form-item label="产品">
            <product-select
              :value.sync="formSearch.afid"
              placeholder="请选择产品"
              @change="handerAfid"
              :isDefault="true"
              popper-class="BI-select BI-select-product"
            >
              <!-- <el-option label="全部" :value="null"></el-option> -->
            </product-select>
          </el-form-item>
          <el-form-item label="地区">
            <areaMultiSelect
              :value.sync="formSearch.geo"
              :optionsList="countryList"
            >
            </areaMultiSelect>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit('formSearch')"
              >查询</el-button
            >
            <el-button
              @click="$router.push({ name: 'popuManual' })"
              type="primary"
              >录入数据</el-button
            >
          </el-form-item>
        </el-col>
      </el-form>
    </el-col>
    <el-col :span="4" class="headerleft">
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <i class="el-icon-refresh" @click="onSubmit('formSearch')" />
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="下载excel"
        placement="top"
      >
        <i class="el-icon-download" @click="downloadFile" />
      </el-tooltip>
      <!-- <el-tooltip class="item" effect="dark" content="上传excel" placement="top">
        <i class="el-icon-upload2" @click="uploadFile" />
      </el-tooltip> -->
    </el-col>
  </el-row>
</template>
<script>
import { changeshortcutclass, clearallshortcutclass } from "@/utils/tool";
import moment from "moment";
import areaMultiSelect from "@/components/areaMultiSelect.vue";
export default {
  components: {
    areaMultiSelect,
  },
  computed: {},
  mounted: function () {
    const timer = setInterval(() => {
      if (this.formSearch.afid) {
        clearInterval(timer);
        this.$store.dispatch("getCountryList", {
          afid: this.formSearch.afid,
          cb: (result) => {
            this.countryList = result;
            let param = {
              pageSize: 500,
              pageNumber: 1,
              dateStart: moment(this.formSearch.formdate[0]).format("YYYYMMDD"),
              dateEnd: moment(this.formSearch.formdate[1]).format("YYYYMMDD"),
              afid: this.formSearch.afid,
              geo: this.formSearch.geo.join(","),
              dimension: this.formSearch.dimension,
            };
            this.$store.dispatch("getExtenSionList", {
              param,
              cb: (data) => {
                this.$emit("setExtensionHeaderColumn", {
                  col: data.mediaSourceList,
                  header: data.popuList[0],
                  def: param.dimension,
                  // 货币符号
                  sign: data.mediaSourceCurrencyList,
                });
              },
            });
          },
        });
      }
    }, 200);
  },
  data() {
    return {
      countryList: [],
      formSearch: {
        formdate: [
          new Date(new Date().getTime() - 3600 * 1000 * 24 * 6),
          new Date(),
        ],
        afid: null,
        geo: [],
        dimension: "1",
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "当天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("当天", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一周", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一个月", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近2个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近2个月", picker.$el);
              }, 0);
            },
          },
        ],
        onPick: function ({ maxDate, minDate }) {
          clearallshortcutclass(this.$el);
          console.log(maxDate, minDate);
        },
        // disabledDate: function(time) {
        //   return time.getTime() > Date.now();
        // }
        disabledDate: function (date) {
          if (new Date().getTime() - date.getTime() > 0) {
            return false;
          }
          return true;
        },
      },
      value1: "",
      value2: "",
    };
  },
  methods: {
    onSubmit(formName) {
      this.$emit("showLoding");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            pageSize: 500,
            pageNumber: 1,
            dateStart: moment(this.formSearch.formdate[0]).format("YYYYMMDD"),
            dateEnd: moment(this.formSearch.formdate[1]).format("YYYYMMDD"),
            afid: this.formSearch.afid,
            geo: this.formSearch.geo.join(","),
            dimension: this.formSearch.dimension,
          };
          this.$store.dispatch("getExtenSionList", {
            param,
            cb: (data) => {
              this.$emit("setExtensionHeaderColumn", {
                col: data.mediaSourceList,
                header: data.popuList[0],
                def: param.dimension,
                // 货币符号
                sign: data.mediaSourceCurrencyList,
              });
            },
          });
        } else {
          return false;
        }
      });
    },
    downloadFile() {
      this.$emit("downloadFile");
    },
    uploadFile() {
      this.$emit("showUploadFile");
    },
    handerAfid(e) {
      this.formSearch.geo = [];
      this.$store.dispatch("getCountryList", {
        afid: e,
        cb: (result) => {
          this.countryList = result;
        },
      });
    },
  },
};
</script>
<style lang="less" rel="stylesheet/less" scoped>
@borderline: #e6e6e6;
.el-date-editor--daterange {
  width: 483px;
}
.el-button {
  // margin-left: 186px;
}
.userheder {
  padding: 10px;
  // border: 1px solid #e6e6e6;
  margin: 2px;
  border-radius: 3px;
  align-items: baseline;
  display: flex;
  min-width: 1000px;
  overflow-x: auto;
}
.headerleft {
  text-align: right;
  i {
    font-size: 20px;
    margin-right: 10px;
    cursor: pointer;
  }
  i:hover {
    color: #409eff;
  }
}
.el-form-item {
  margin-bottom: 0px;
}
.date {
  // margin-bottom: 10px;
  .date-wrap {
    position: relative;
    top: 3px;
    /deep/ .el-form-item__label {
      line-height: 30px;
    }
  }
}
</style>
